import { render, staticRenderFns } from "./FenPeiFeiYong.vue?vue&type=template&id=8a981472&scoped=true"
import script from "./FenPeiFeiYong.vue?vue&type=script&lang=js"
export * from "./FenPeiFeiYong.vue?vue&type=script&lang=js"
import style0 from "./FenPeiFeiYong.vue?vue&type=style&index=0&id=8a981472&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a981472",
  null
  
)

export default component.exports